export default __webpack_public_path__ + "static/media/morocco9.7ab8cfa8.jpg";